import axios from 'axios';

const state = {
  solicitudesEdicion: null,
  solicitudEdicionSeleccionada: null,
  mensaje: '',
};

const getters = {
  solicitudesEdicion: (state) => state.solicitudesEdicion,
  solicitudEdicionSeleccionada: (state) => state.solicitudEdicionSeleccionada,
  mensaje: (state) => state.mensaje,
};

const mutations = {
  setSolicitudesEdicion: (state, solicitudesEdicion) => {
    state.solicitudesEdicion = solicitudesEdicion;
  },
  setSolicitudEdicionSeleccionada: (state, solicitudEdicionSeleccionada) => {
    state.solicitudEdicionSeleccionada = solicitudEdicionSeleccionada;
  },
  setMensaje: (state, mensaje) => {
    state.mensaje = mensaje;
  },
};

const actions = {
  async consultar({ commit }) {
    try {
      const res = await axios.get(`/v1/usuarios/solicitud/pendientes`);
      const solicitudes = res?.data?.result.map((s) => {
        return {
          id: s.id,
          usuario: s.usuario,
          oldData: JSON.parse(s.datosViejos),
          newData: JSON.parse(s.datosNuevos),
        }
      });
      commit('setSolicitudesEdicion', solicitudes);
    } catch (error) {
      commit('setSolicitudesEdicion', []);
      return error;
    }
  },
  async aprobar({ commit, state }, data) {
    try {
      await axios.put(`/v1/usuarios/solicitud/${data.id}/aprobar`, { observacion: data.observacion });
      let actualizados = state.solicitudesEdicion.filter((solicitud) => solicitud.id !== data.id);
      commit('setSolicitudesEdicion', actualizados);
      commit('setMensaje', 'Solicitud aprobada con éxito');
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || 'Error al aprobar la solicitud';
      throw new Error(errorMessage);
    }
  },
  async rechazar({ commit, state }, data) {
    try {
      await axios.put(`/v1/usuarios/solicitud/${data.id}/rechazar`, { motivoRechazo: data.motivoRechazo });
      let actualizados = state.solicitudesEdicion.filter((solicitud) => solicitud.id !== data.id);
      commit('setSolicitudesEdicion', actualizados);
      commit('setMensaje', 'Solicitud rechazada con éxito');
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || 'Error al rechazar la solicitud';
      throw new Error(errorMessage);
      
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
